import compact from "lodash/compact";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import PropTypes from "prop-types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import AvailabilityRangeItem from "./availability_range_item";
import { CheckboxesItem } from "./checkboxes_item";
import { ExpandedFilterWrapper } from "./components/expanded_filter_wrapper";
import DateItem from "./date_item";
import DateRangeItem from "./date_range_item";
import { AvailabilityFilterItem } from "./filter_items";
import { IntegerItem } from "./integer_item";
import { RadioButtonsItem } from "./radio_buttons_item";
import ReportingRangeItem from "./reporting_range_item";
import { SearchItem } from "./search_item";
import { SelectManyItem } from "./select_many_item";
import { SelectOneItem } from "./select_one_item";

const AnyFilter = (props) => {
  const { t } = useTranslation("filters");
  const { customTypes } = useCustomTypes();

  const isOrderable = customTypes.find((customType) => customType.name === props.filter.name)?.orderable;

  const labelIcons = useMemo(
    () =>
      compact([
        props.labelTooltip,
        isOrderable && {
          icon: "hierarchical",
          text: t("hierarchicalFilterMessage")
        },
        props.filter.segment && {
          icon: "segment",
          text: t("segmentFilterMessage")
        }
      ]),
    [props.labelTooltip, props.filter.segment, isOrderable, t]
  );

  switch (props.filter.type) {
    case "availability":
      return <AvailabilityFilterItem {...props} />;
    case "select_many":
      return <SelectManyItem {...props} onChange={props.handleChange} labelIcons={labelIcons} />;
    case "select_one":
      return <SelectOneItem {...props} onChange={props.handleChange} labelIcons={labelIcons} />;
    case "string":
      return <SearchItem {...props} label={props.filter.title} labelIcons={labelIcons} />;
    case "number":
      return <IntegerItem {...props} label={props.filter.title} />;
    case "radio_buttons":
      return <ExpandedFilterWrapper {...props} onChange={props.handleChange} component={RadioButtonsItem} />;
    case "checkboxes":
      return <ExpandedFilterWrapper {...props} onChange={props.handleChange} component={CheckboxesItem} />;
    case "date":
      return <DateItem {...props} />;
    case "date_range":
      return <DateRangeItem {...props} />;
    case "reporting_range":
      return <ReportingRangeItem {...props} onChange={props.handleChange} />;
    case "availability_range":
      return <AvailabilityRangeItem {...props} />;
    case "hidden":
      return null;
    default:
      return (
        <b style={{ display: "block", padding: 8, border: "1px solid red" }}>{props.filter.type} (??)</b>
      );
  }
};

AnyFilter.propTypes = {
  handleChange: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    operator: PropTypes.string
  }),
  templateKey: PropTypes.string,
  labelTooltip: PropTypes.shape({
    text: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired
  })
};

export default AnyFilter;
